import style from './Input.module.scss'
export interface InputProps {
  label?: string
  type?: string
  errorMessage?: any
  disabled?: boolean
  marginBottom?: boolean
  prefixIcon?: string
  name: string
  register: any
  min?: string
  max?: string
  placeholder?: string
  outsideLabel?: boolean
  required?: boolean
}

const Input = ({
  label,
  type = 'text',
  errorMessage,
  disabled = false,
  marginBottom = true,
  prefixIcon = '',
  register,
  name,
  min,
  max,
  placeholder,
  outsideLabel,
  required,
}: InputProps) => {
  return (
    <div
      className={`${style.inputField} ${prefixIcon && style.prefixIcon} ${
        !marginBottom && style.noSpacing
      }`}
    >
      {outsideLabel && label && (
        <div className={style.inputField__outsideLabelContainer}>
          <label className={style.inputField__outsideLabel}>{label}</label>
          {required && <span className={style.inputField__required}>*</span>}
        </div>
      )}
      <div className={style.inputField__inner}>
        <input
          type={type}
          placeholder={outsideLabel ? placeholder : placeholder || label}
          disabled={disabled}
          min={min}
          max={max}
          required={required}
          {...register(name)}
        />
        {/* {label && <label>{label}</label>} */}
        {['date', 'time'].includes(type) && <div className={style.inputField__dateIconHide}></div>}

        {prefixIcon && (
          <div className={`${style.inputField__icon}`}>
            <img src={prefixIcon} alt="icon" />
          </div>
        )}
      </div>
      {errorMessage && <span>{errorMessage}</span>}
    </div>
  )
}
export default Input
